// store/index.js
import { configureStore } from '@reduxjs/toolkit';
import storeDetailsReducer from '../reducer/storeDetails/storeDetailsSlice';
import currentPlanReducer from '../reducer/currentPlan/currentPlanSlice';

export const store = configureStore({
  reducer: {
    storeDetails: storeDetailsReducer,
    currentPlan: currentPlanReducer,
  },
});